import { transient } from "aurelia-dependency-injection";
import { RuleConfigBroker, RuleConfigBrokerSaveModel, RuleConfigBrokerParameters } from "../../../../../../../models/vetting/vetting.models";

@transient()
export class BaseRuleConfigPlugin {
    meta:RuleConfigBrokerSaveModel;
    parameters:RuleConfigBrokerParameters;
    isReadOnly: boolean = false;
    activate(model: { broker: RuleConfigBroker, isReadOnly: boolean }){
        this.meta = model.broker.model;
        this.parameters = model.broker.parameters;
        this.isReadOnly = model.isReadOnly == true;
    }
}